/* global axios */
import ApiClient from './ApiClient';

class KanbanReportsAPI extends ApiClient {
  constructor() {
    super('kanban_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getByFunnel(params = {}) {
    return axios.get(`${this.url}/by_funnel`, { params });
  }

  getByStage(params = {}) {
    return axios.get(`${this.url}/by_stage`, { params });
  }

  getByAgent(params = {}) {
    return axios.get(`${this.url}/by_agent`, { params });
  }

  getConversionFunnel(params = {}) {
    return axios.get(`${this.url}/conversion_funnel`, { params });
  }

  getStageDistribution(params = {}) {
    return axios.get(`${this.url}/stage_distribution`, { params });
  }

  getTimeInStages(params = {}) {
    return axios.get(`${this.url}/time_in_stages`, { params });
  }

  getSalesAttribution(params = {}) {
    return axios.get(`${this.url}/sales_attribution`, { params });
  }

  downloadPdf(params = {}) {
    return axios.get(`${this.url}/download_pdf`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new KanbanReportsAPI();
